import { edmCampaign } from '@bingads-webui/edm-campaign';

export const getAssetGroupsEDM = ({ cid, aid, audienceGroupId }) =>
  edmCampaign
    .Customers.$withKey(cid)
    .Accounts.$withKey(aid)
    .AudienceGroups.$withKey(audienceGroupId)['Default.GetAssetGroupsByAudienceGroupId'];
